import React from "react";
var SearchContentBlock = function (props) {
    return (React.createElement("div", { className: "searchblock-generic-block d-flex justify-content-between align-items-start gap-20 ".concat(!props.edit && "hand_cursor"), onClick: function () {
            !props.edit && props.onSelected && props.onSelected();
        } },
        React.createElement("div", null,
            React.createElement("div", null, props.topleft),
            props.bottomleft && React.createElement("div", { className: "mgt-5" }, props.bottomleft)),
        props.edit ? (props.editAction) : (React.createElement("div", { className: "taRight" },
            React.createElement("div", { className: " DMSansNormal_12_400 txt-midnight-blue lh-140" }, props.topright),
            props.bottomRight && (React.createElement("div", { className: "mgt-5 d-center-end" }, props.bottomRight))))));
};
export default SearchContentBlock;
